import utils from "./utils";

export default class ActivitiesAndTasks {
  constructor(api) {
    this.api = api;
  }
  /////// FIELD MANAGEMENT REQUEST ///////
  getAllActivities(queryParams, onSuccess, onError) {
    let params = "";
    for (const [query, value] of Object.entries(queryParams)) {
      params += params === "" ? "?" : "&";
      params += query + "=" + value;
    }
    return this.api.http_weezie_fiber
      .get("api/v1/activities" + params)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  ////// NETWORK WORKSPACE (DYNAMIC FORM TAB) /////////
  getObjectActivities(filters, append, onSuccess, onError) {
    let extras = utils.getPreparedExtras(filters, null, append);
    if (extras !== "") {
      extras = "&" + extras;
    }

    return this.api.http_weezie_fiber
      .get("api/v1/activities?paginate=false" + extras)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  /////// HOME NETWORK MAIN TAB REQUEST (ACTIVITIES) /////////

  getMyActivities(filters, append, onSuccess, onError, timestamp) {
    let extras = utils.getPreparedExtras(filters, null, append);
    if (extras !== "") {
      extras = "&" + extras;
    }

    return this.api.http_weezie_fiber
      .get("api/v1/objects/myactivities" + extras, {
        headers: {
          'timestamp': timestamp
        }
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getActivityByUUID(activityUUID, includes, append, onSuccess, onError) {
    let extras = utils.getPreparedExtras(null, includes, append);
    if (extras !== "") {
      extras = "?" + extras;
    }
    return this.api.http_weezie_fiber
      .get(
        "api/v1/activities/" +
          activityUUID +
          extras
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createActivity(activityData, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .post("api/v1/activities", activityData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  updateActivity(activityUUID, updatedData, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .patch("api/v1/activities/" + activityUUID, updatedData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteActivity(activityUUID, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .delete("api/v1/activities/" + activityUUID)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getTasksByActivityUuid(activityUUID, queryParams, onSuccess, onError) {
    let params = "";
    for (const [query, value] of Object.entries(queryParams)) {
      params += params === "" ? "?" : "&";
      params += query + "=" + value;
    }
    return this.api.http_weezie_fiber
      .get("api/v1/activities/" + activityUUID + "/tasks" + params)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getTaskByUUID(taskUUID, includes, onSuccess, onError) {
    let extras = utils.getPreparedExtras(null, includes);
    if (extras !== "") {
      extras = "?" + extras;
    }
    return this.api.http_weezie_fiber
      .get("api/v1/tasks/" + taskUUID + extras)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getPriorityList(onSuccess, onError) {
    return this.api.http_weezie_fiber
      .get("api/v1/lists/priorities")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createTask(activityUUID, taskData, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .post("api/v1/activities/" + activityUUID + "/tasks/", taskData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  updateTask(taskUUID, updatedData, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .put("api/v1/tasks/" + taskUUID, updatedData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteTask(taskUUID, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .delete("api/v1/tasks/" + taskUUID)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  approveTask(taskUUID, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .put("api/v1/tasks/" + taskUUID + "/approve", { approve: true })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  rejectTask(taskUUID, rejectionObject, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .put("api/v1/tasks/" + taskUUID + "/approve", rejectionObject)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createTaskContent(taskUUID, updatedData, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .post("api/v1/tasks/" + taskUUID + "/steps", updatedData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  updateTaskContent(taskUUID, contentUUID, updatedData, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .put("api/v1/tasks/" + taskUUID + "/steps/" + contentUUID, updatedData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  deleteTaskContent(taskUUID, contentUUID, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .delete("api/v1/tasks/" + taskUUID + "/steps/" + contentUUID)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getStepsByTaskUuid(taskUUID, queryParams, onSuccess, onError) {
    let params = "";
    for (const [query, value] of Object.entries(queryParams)) {
      params += params === "" ? "?" : "&";
      params += query + "=" + value;
    }
    return this.api.http_weezie_fiber
      .get("api/v1/tasks/" + taskUUID + "/steps" + params)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  exportWorkorder(uuid, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .get("api/v1/workorders/" + uuid + "/export")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  exportActivity(uuid, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .get("api/v1/activities/" + uuid + "/export")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  exportTask(uuid, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .get("api/v1/tasks/" + uuid + "/export")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  ////////////////////////////////////////////////////////////////// ACTIVITY TEMPLATES \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  getAllActivityTemplates(onSuccess, onError) {
    return this.api.http_weezie_fiber
      .get("api/v1/templates/activities?include=tasks&paginate=false")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createActivityTemplate(activityTemplateData, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .post("api/v1/templates/activities?include=tasks", activityTemplateData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getActivityTemplateByUUID(activityUUID, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .get("api/v1/templates/activities/" + activityUUID + "?include=tasks")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  updateActivityTemplate(activityUUID, updatedData, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .put("api/v1/templates/activities/" + activityUUID, updatedData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  removeActivityTemplate(activityUUID, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .delete("api/v1/templates/activities/" + activityUUID)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  ///////////////////////////////////////////////////// TASK TEMPLATES \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  getAllTaskTemplates(onSuccess, onError) {
    return this.api.http_weezie_fiber
      .get("api/v1/templates/tasks?paginate=false")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  createTaskTemplate(taskTemplateData, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .post("api/v1/templates/tasks", taskTemplateData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getTaskTemplateByUUID(taskUUID, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .get("api/v1/templates/tasks/" + taskUUID)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  updateTaskTemplate(taskUUID, updatedData, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .put("api/v1/templates/tasks/" + taskUUID, updatedData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  removeTaskTemplate(taskUUID, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .delete("api/v1/templates/tasks/" + taskUUID)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  getTaskTemplateContent(taskUUID, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .get("api/v1/templates/tasks/" + taskUUID + "/steps?paginate=false")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  createTaskTemplateContent(taskUUID, updatedData, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .post("api/v1/templates/tasks/" + taskUUID + "/steps", updatedData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  updateTaskTemplateContent(
    taskUUID,
    contentUUID,
    updatedData,
    onSuccess,
    onError
  ) {
    return this.api.http_weezie_fiber
      .put(
        "api/v1/templates/tasks/" + taskUUID + "/steps/" + contentUUID,
        updatedData
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  deleteTaskTemplateContent(taskUUID, contentUUID, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .delete("api/v1/templates/tasks/" + taskUUID + "/steps/" + contentUUID)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
  unblockTask(taskUUID, updatedData, onSuccess, onError) {
    return this.api.http_weezie_fiber
      .put("api/v1/tasks/" + taskUUID + "/block", updatedData)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/api/activities_and_tasks.js